import images from "@/assets/images";
import Button from "@/components/Button";
import React from "react";
import classnames from "classnames";
import { Popover } from "antd";
import { clickGeneralDownload } from "@/report";
import { useAnimationTime } from "@/hooks";
import { downloadFile } from "@/utils";
import Constants from "@/constants";

interface ILiveAppProps {
  isBigScreen?: boolean;
}
const LiveApp: React.FC<ILiveAppProps> = ({ isBigScreen }) => {
  if (isBigScreen)
    return (
      <div className="flex h-full items-center justify-between">
        <Left isBigScreen={isBigScreen} className="max-mr-[16px] ml-[100px]" />
        <Right className="u-max-w-[750px] mr-[95px]" />
      </div>
    );
  return (
    <div className="mt-[34px]">
      <Left isBigScreen={isBigScreen} className="ml-[60px]" />
      <div className="ml-[40px] mr-[45px] mt-[32px]">
        <Right />
      </div>
    </div>
  );
};
interface ILeftProps {
  className?: string;
  isBigScreen?: boolean;
}
const Left: React.FC<ILeftProps> = ({ className, isBigScreen }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <div
      className={classnames(
        "shrink-0",
        className,
        "content-wrap-animation",
        !isAnimationFirst && "!ani-delay-0",
      )}
    >
      <div className={classnames("title-animation", !isAnimationFirst && "!ani-delay-0")}>
        <p className="max-text-[42px] max-leading-[42px] text-[#FFF]">虎牙直播主播端</p>
        <p className="max-text-[52px] max-leading-[52px] mt-[20px] text-[#fff]">
          功能强大，快速上手
        </p>
      </div>

      <p
        className={classnames(
          "version-animation max-text-[16px] max-leading-[22px] my-[32px] flex items-center whitespace-break-spaces text-[#FFFFFF99]",
          !isAnimationFirst && "!ani-delay-0",
        )}
      >
        {`虎牙直播主播端具有强大的开播功能支持，多样的开播玩法选择，有效\n帮助你提高直播内容质量，创造更多有趣的直播效果！`}
      </p>
      <div
        className={classnames(
          "download-button-animation flex",
          !isAnimationFirst && "!ani-delay-300",
        )}
      >
        <Button
          className="bg-primary u-max-w-[175px] u-max-h-[52px]"
          onClick={() => {
            downloadFile(Constants.DOWNLOAD_URL.LIVE_PC);
            clickGeneralDownload({
              button_name: "PC客户端",
              product_name: "6",
            });
          }}
        >
          <div className="flex items-center">
            <img src={images.iconWindow} className="u-max-w-[28px] u-max-h-[28px] mr-[8px]" />
            <p className="max-text-[18px] font-[500] text-[#0B0B0B]">PC客户端</p>
          </div>
        </Button>
        <div className="u-max-w-[204px] ml-[20px]">
          <Popover
            className="w-content"
            content={<PopoverContent />}
            trigger="hover"
            placement={isBigScreen ? "bottomLeft" : "rightBottom"}
          >
            {/* 必须包个div才行 */}
            <div>
              <Button className="u-max-w-[204px] u-max-h-[52px] bg-[#FFFCED]">
                <div className="flex items-center">
                  <img src={images.iconApp} className="u-max-w-[28px] u-max-h-[28px] mr-[8px]" />
                  <p className="max-text-[18px] font-[500] text-[#000]">直播助手APP</p>
                </div>
              </Button>
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};
const PopoverContent = () => {
  return (
    <div className="flex h-[142px] w-[340px] rounded-[4px] bg-[#292929] p-[16px]">
      <img src={images.qrcode_live} className="mr-[12px] h-[110px] w-[110px]" />
      <div className="flex flex-1 flex-col justify-between">
        <div>
          <p className="text-[14px] font-[500] leading-[20px] text-[#fff]">手机或平板扫码下载</p>
          <p className="mt-[8px] text-[12px] font-[500] leading-[17px] text-[#FFFFFF99]">
            或手动下载安装包
          </p>
        </div>
        <div className="flex w-full items-center justify-between">
          <div
            className="flex cursor-pointer"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.ZS_IOS);
              clickGeneralDownload({
                button_name: "iOS安装包",
                product_name: "6",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">iOS安装包</p>
          </div>
          <div
            className="flex cursor-pointer"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.ZS_ADR);
              clickGeneralDownload({
                button_name: "安卓安装包",
                product_name: "6",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">安卓安装包</p>
          </div>
        </div>
      </div>
    </div>
  );
};

interface IRightProps {
  className?: string;
}
const Right: React.FC<IRightProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <div
      id="live-app-product"
      className={classnames(
        "product-animation relative",
        className,
        !isAnimationFirst && "!ani-delay-150",
      )}
    >
      <img src={images.PCLive} className="w-full" id="live-app-product-image" />
      <img
        src={images.iconMike}
        className="mike-animation u-max-w-[120px] absolute bottom-[30px] right-[-33px]"
      />
    </div>
  );
};

export default LiveApp;
